// src/hooks/useToast.js
import { useState, useCallback } from 'react';
import Toast from '../components/Toast';

export function useToast() {
  const [toast, setToast] = useState(null);

  const show = useCallback((message, type = 'success') => {
    setToast({ message, type, key: Date.now() });
  }, []);

  const ToastView = toast ? (
    <Toast key={toast.key} message={toast.message} type={toast.type} onDone={() => setToast(null)} />
  ) : null;

  return { show, ToastView };
}
